export default "__VITE_PUBLIC_ASSET__51cad8b7__"